var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.198,
    height: 27,
    viewBox: "0 0 24.198 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39945",
    "data-name": "Group 39945",
    transform: "translate(-26.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39944",
    "data-name": "Group 39944",
    transform: "translate(26.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39943",
    "data-name": "Group 39943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143397",
    "data-name": "Path 143397",
    d: "M119.432,201.055A1.055,1.055,0,0,0,118.377,200H107.514a1.055,1.055,0,0,0,0,2.109h10.863A1.055,1.055,0,0,0,119.432,201.055Z",
    transform: "translate(-102.246 -189.453)",
    fill: "#71717d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143398",
    "data-name": "Path 143398",
    d: "M107.514,280a1.055,1.055,0,0,0,0,2.109h6.6a1.055,1.055,0,1,0,0-2.109Z",
    transform: "translate(-102.246 -265.234)",
    fill: "#71717d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143399",
    "data-name": "Path 143399",
    d: "M34.316,24.891H30.789a2.112,2.112,0,0,1-2.109-2.109V4.219a2.112,2.112,0,0,1,2.109-2.109H43.756a2.112,2.112,0,0,1,2.109,2.109v6.486a1.055,1.055,0,1,0,2.109,0V4.219A4.224,4.224,0,0,0,43.756,0H30.789A4.224,4.224,0,0,0,26.57,4.219V22.781A4.224,4.224,0,0,0,30.789,27h3.527a1.055,1.055,0,0,0,0-2.109Z",
    transform: "translate(-26.57)",
    fill: "#71717d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143400",
    "data-name": "Path 143400",
    d: "M255.292,272.949a3.167,3.167,0,0,0-4.474,0l-5.79,5.778a1.055,1.055,0,0,0-.264.44l-1.261,4.152a1.055,1.055,0,0,0,1.291,1.323l4.257-1.179a1.055,1.055,0,0,0,.464-.27l5.778-5.767A3.168,3.168,0,0,0,255.292,272.949ZM248.22,281.5l-2.142.593.627-2.063,3.907-3.9,1.492,1.492Zm5.581-5.571-.2.2-1.492-1.492.2-.2a1.055,1.055,0,0,1,1.492,1.491Z",
    transform: "translate(-232.02 -257.679)",
    fill: "#71717d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143401",
    "data-name": "Path 143401",
    d: "M118.377,120H107.514a1.055,1.055,0,0,0,0,2.109h10.863a1.055,1.055,0,0,0,0-2.109Z",
    transform: "translate(-102.246 -113.672)",
    fill: "#71717d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessNote);
export default __webpack_public_path__ + "static/media/businessNote.b853b1b077688fe459afea1385188ea9.svg";
export { ForwardRef as ReactComponent };